import styled from 'styled-components';

export const LoaderBox = styled.div`
  margin: auto;
  width: 75px;
`;

export const LoaderImage = styled.img`
  width: 100%;
  border-radius: 50px;
`;
